import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useTenantTranslation } from "hooks/formatters";
import { ScrapEyeInstallationListOption } from "src/store/api/generatedApi";

export function InstallationViewToggle({
  value,
  onChange,
}: {
  value: ScrapEyeInstallationListOption;
  onChange: (view: ScrapEyeInstallationListOption) => void;
}) {
  const { t } = useTenantTranslation();

  return (
    <Box>
      <ToggleButtonGroup
        exclusive
        size="small"
        value={value}
        onChange={(_event, nextView: ScrapEyeInstallationListOption | null) => {
          if (nextView != null) {
            onChange(nextView);
          }
        }}
      >
        <ToggleButton value="current">{t("current")}</ToggleButton>
        <ToggleButton value="all">{t("all")}</ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}
